import createCache, { type EmotionCache } from '@emotion/cache';

/**
 * Shared Emotion cache factory used by both the server render (critical-CSS
 * extraction) and the client hydration. Both sides MUST use the same `key` so
 * the generated class names match and hydration is stable. `prepend` keeps MUI's
 * styles ahead of other stylesheets, matching MUI's default cache behaviour.
 */
export function createEmotionCache(): EmotionCache {
    return createCache({ key: 'css', prepend: true });
}
